<template>
  <li
    :class="[
      $style.progressStep,
      { [$style.isActive]: active },
      { [$style.isValid]: valid },
      { [$style.firstItem]: firstItem },
    ]"
    @click="stepClicked"
  >
    <a :class="$style.progressLink" href="javascript:">
      <div :class="$style.progressContainer">
        <div v-if="firstItem === false" :class="$style.progressPath">
          <span :class="$style.progressPathDefault"></span>
          <span
            :class="[
              $style.progressPathIsactive,
              { [$style.isActive]: active },
              { [$style.isValid]: valid },
            ]"
          ></span>
        </div>

        <div
          :class="[
            $style.progressMarker,
            { [$style.isActive]: active },
            { [$style.isValid]: valid },
          ]"
        >
          <span v-if="active" :class="$style.progressMarkerContent">{{
            index
          }}</span>
          <icon
            v-else-if="valid"
            icon="check"
            :class="[$style.progressMarkerContentSmall]"
          ></icon>
        </div>
      </div>

      <div :class="[$style.progressText, { [$style.isActive]: active }, { [$style.isComplete]: complete }]">
        <p>{{ label }}</p>
      </div>
    </a>
  </li>
</template>

<script>
import icon from "./icon";

export default {
  name: "stepper-step-fragment",
  components: { icon },
  props: {
    label: { type: String, required: true },
    index: { type: Number, required: true },
    active: { type: Boolean, default: false },
    valid: { type: Boolean, default: false },
    complete: { type: Boolean, default: false },
    firstItem: { type: Boolean, default: false },
  },
  methods: {
    stepClicked() {
      this.$emit("step-clicked");
    },
  },
};
</script>

<style module lang="scss">
@import "../../style/abstract/abstract.colors.scss";
@import "../../style/abstract/abstract.functions.scss";
@import "../../style/abstract/abstract.spacing.scss";
@import "../../style/abstract/abstract.typography.scss";

.progressStep {
  font-family: $font-family;
  width: 100%;
  list-style: none;
  margin: 0;
  padding: 0;

  &.firstItem {
    width: auto;
  }
}

.progressText {
  color: $color-dimgrey-lighter;
  font-size: rem-calc(14);
  line-height: 1;
  width: rem-calc(80);
  margin-left: auto;
  margin-right: rem-calc(-30);
  text-align: center;
  display: none;

  @media only screen and (min-device-width: 320px) and (max-device-width: 480px) and (-webkit-min-device-pixel-ratio: 2) {
    p {
      display: none;
    }
  }

  @media (min-width: 31.25em) {
    display: block;
  }

  &.isActive, &.isComplete {
    font-weight: bold;
    margin-right: rem-calc(-25);
  }
}

.progressPath {
  position: relative;
  width: 100%;
  grid-area: 1/1/3/3;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.progressPathDefault {
  background-color: $color-silver;
  width: 100%;
  height: rem-calc(3);
  position: absolute;
}

.progressPathIsactive {
  transition: all 0.5s;
  background-color: $color-primary;
  height: rem-calc(5);
  position: absolute;
  width: 0;

  &.isValid,
  &.isActive {
    width: 100%;
  }
}

.progressContainer {
  display: grid;
}

.progressLink {
  text-decoration: none;
}

.progressMarker {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: $color-silver;
  width: rem-calc(20);
  height: rem-calc(20);
  border-radius: 100%;
  color: $color-white;
  grid-area: 1/2/3/2;
  z-index: 1;
  margin: rem-calc(5) 0 rem-calc(5) auto;

  &.isValid {
    background-color: $color-primary;
  }

  &.isActive {
    background-color: $color-primary;
    margin: 0 0 0 auto;
    width: rem-calc(30);
    height: rem-calc(30);
  }
}

.progressMarkerContentSmall {
  &:before {
    font-size: rem-calc(8);
  }
}
</style>
